/**
 * This file sets up our custom validator code, which follows the same rules as jQuery Validator except it has much less functionality.
 * The choice for a custom validator code was chosen because jQuery Validator was too extensive and using Validator with (a constantly updated DOM by) Vue.js did not work well.
 *
 * An input should have at least:
 * - data-val="true"
 *
 * If the input is required:
 * - data-val-required="required"
 *
 * If the input has a regex:
 * - data-val-regex="[message]"
 * - data-val-regex-pattern="[^\s]{3,}"
 *
 * An optional span for the error message can be created. If it doesn't exist, it is automatically created and added after the input.
 * - data-valmsg-for="[name]"
 * - class="validation-message"
 *
 * If invalid
 * - validation-error is added to the closest div to the input
 * - the validation message is added to the [data-valmsg-for]
 *
 * customValidation
 * - use this on an input to validate it according to val-required and val-regex-pattern
 *
 * isInputValid
 * - returns a Boolean whether or not all inputs that follow our validator's rules (those that have data-val=true) are valid
 *
 * validateAll
 * - validates all inputs that follow our validator's rules (those that have data-val=true)
 */

function validator() {
	function customValidation() {
		let name = $(this).attr('name');
		if (name == null) {
			name = $(this).attr('id');
		}
		if (name == null || name == '') {
			console.error("No 'id' or 'name' attribute on item to validate", $(this));
		}
		if ($(`[data-valmsg-for="${name}"]`).length == 0) {
			/* append error span after */
			$(this).after(`<span data-valmsg-for="${name}" class="mui-form-helper validation-message"></span>`);
		}
		/* reset text message to nothing */
		$(`[data-valmsg-for="${name}"]`).text('');

		if ($(this).data('val-required') && $(this).val() == '') {
			$(this)
				.closest('div')
				.addClass('validation-error');
			$(`[data-valmsg-for="${name}"]`).text($(this).data('val-required'));
		} else {
			$(this)
				.closest('div')
				.removeClass('validation-error');
			if ($(this).data('val-regex-pattern')) {
				let pattern = $(this).data('val-regex-pattern');
				pattern = pattern.replace("@('@')", '@'); // razor fix
				const val = $(this).val();
				let regex = new RegExp(pattern);
				if (!regex.test(val)) {
					$(`[data-valmsg-for="${name}"]`).text($(this).data('val-regex'));
					$(this)
						.closest('div')
						.addClass('validation-error');
				}
				regex = null;
			}
		}
	}

	window.isInputValid = function(selector) {
		if (selector == null) {
			selector = 'body';
		}
		/* revalidate all inputs */
		$('[data-val="true"]', selector).each(customValidation);

		return $('.validation-error', selector).length == 0;
	};

	window.validateAll = function() {
		$('input, textarea', '[data-val="true"]').each(customValidation);
	};

	/* global register validation */
	$(document).on('change input blur', '[data-val="true"]', customValidation);

	$(document).delegate('.js-allow-textarea-tab', 'keydown', function(e) {
		const keyCode = e.keyCode || e.which;

		if (keyCode == 9) {
			e.preventDefault();
			const start = $(this).get(0).selectionStart;
			const end = $(this).get(0).selectionEnd;

			/* set textarea value to: text before caret + tab + text after caret */
			$(this).val(
				`${$(this)
					.val()
					.substring(0, start)}\t${$(this)
					.val()
					.substring(end)}`
			);

			/* put caret at right position again */
			$(this).get(0).selectionStart = $(this).get(0).selectionEnd = start + 1;
		}
	});
}
validator();
